// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2obYj","label":"CategoryService_label__1CFly","location":"CategoryService_location__2ovRM"};